import React, { useState } from 'react';
import { Gem, Loader2, Check, ShieldAlert } from 'lucide-react';
import { gbApi, gbFmt, gbError } from './gbApi';
import { gbAviso } from './GbNotice';

const ITEMS = [
  { key: 'pocao', icon: '/gb/icon_pocao.png', name: 'Poção', desc: 'Recupera 80 de vida na hora',
    tag: 'cura' },
  { key: 'missil', icon: '/gb/icon_missil.png', name: 'Míssil', desc: 'Deixa o próximo tiro com dano dobrado',
    tag: 'ataque' },
  { key: 'tornado', icon: '/gb/icon_tornado.png', name: 'Tornado', desc: 'Desvia o tiro que vier do adversário',
    tag: 'defesa' },
  { key: 'caveira', icon: '/gb/icon_caveira.png', name: 'Caveira bomba', desc: 'Solta 5 caveirinhas que correm e explodem no rival (4 de dano cada)',
    tag: 'ataque' },
  { key: 'aviao', icon: '/gb/icon_aviao.png', name: 'Reforço aéreo', desc: 'Um avião larga uma caixa secreta no mapa: quem chegar primeiro leva 1 míssil ou 1 poção extra',
    tag: 'apoio' },
];

export const GbShop = ({ player, config, onChange }) => {
  const [busy, setBusy] = useState(null);
  const diamonds = Number(player?.diamonds || 0);
  const precos = config?.shop?.items || {};
  const maxInv = Number(config?.item_max || 3);
  const maxPartida = Number(config?.item_max_match || 1);

  const comprar = async (key) => {
    setBusy(key);
    try {
      await gbApi.post(`/shop/item/${key}`);
      gbAviso.ok('Item guardado no seu inventário!');
      await onChange();
    } catch (e) { gbAviso.erro(gbError(e)); } finally { setBusy(null); }
  };

  return (
    <div data-testid="gb-shop" className="pb-10">
      <h2 className="text-base font-black tracking-wide text-orange-300 md:text-lg">ITENS DE BATALHA</h2>
      <p className="mt-1 text-[11px] text-purple-300/70">
        Pagos em diamantes. Você guarda até <b className="text-amber-300">{maxInv} de cada</b> no inventário e
        pode usar <b className="text-amber-300">{maxPartida} de cada por partida</b> — nas fases e no PvP.
      </p>

      <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {ITEMS.map(({ key, icon, name, desc, tag }) => {
          const preco = Number(precos[key] || 0);
          const tem = Number(player?.items?.[key] || 0);
          const cheio = tem >= maxInv;
          const semGrana = diamonds < preco;
          return (
            <div key={key} data-testid={`gb-item-card-${key}`}
              className={`group relative overflow-hidden rounded-3xl border bg-gradient-to-b from-[#1a1028] to-black p-4 transition-transform hover:-translate-y-0.5 ${
                cheio ? 'border-emerald-700/60' : 'border-purple-800/60'}`}>
              <span className="absolute right-3 top-3 rounded-full bg-black/60 px-2 py-[2px] text-[9px] font-black uppercase tracking-wider text-purple-300/70">
                {tag}
              </span>
              <div className="flex items-start gap-3">
                <div className="flex h-16 w-16 flex-none items-center justify-center rounded-2xl border border-purple-800/60 bg-black/50">
                  <img src={icon} alt={name} className="h-12 w-12 object-contain drop-shadow-[0_0_10px_rgba(255,160,60,.35)]" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-black text-amber-100">{name}</p>
                  <p className="mt-0.5 text-[11px] leading-snug text-purple-200/70">{desc}</p>
                </div>
              </div>

              <div className="mt-3 flex items-center gap-1.5">
                {Array.from({ length: maxInv }).map((_, i) => (
                  <span key={i} data-testid={`gb-item-slot-${key}-${i}`}
                    className={`h-2 flex-1 rounded-full ${i < tem
                      ? 'bg-gradient-to-r from-amber-400 to-orange-500' : 'bg-purple-950'}`} />
                ))}
                <span className="ml-1 font-mono text-[11px] font-black text-amber-300" data-testid={`gb-item-qty-${key}`}>
                  {tem}/{maxInv}
                </span>
              </div>

              <button onClick={() => comprar(key)} disabled={cheio || semGrana || busy === key}
                data-testid={`gb-buy-${key}`}
                className={`mt-3 flex w-full items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-black transition-transform ${
                  cheio ? 'bg-emerald-900/40 text-emerald-300'
                    : 'bg-gradient-to-r from-purple-700 to-fuchsia-700 text-white hover:scale-[1.02] disabled:from-purple-950 disabled:to-purple-950 disabled:text-purple-600 disabled:hover:scale-100'}`}>
                {busy === key ? <Loader2 className="h-4 w-4 animate-spin" />
                  : cheio ? <Check className="h-4 w-4" />
                    : <Gem className="h-4 w-4" />}
                {cheio ? `MÁXIMO ${maxInv} NO INVENTÁRIO` : `COMPRAR · ${gbFmt(preco)}`}
              </button>

              {!cheio && semGrana && (
                <p className="mt-2 flex items-center gap-1 text-[10px] font-bold text-rose-300/80">
                  <ShieldAlert className="h-3 w-3" />faltam {gbFmt(preco - diamonds)} diamantes
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
